const lang = document.querySelector('html').getAttribute('lang')?.split('-')[0];
const langLabels = {
  en: 'English',
  de: 'Deutsch',
};

export { lang, langLabels };
